import {callApi} from "./api";
import * as contract from "../contract";

export const getNotificationsQuery = () => callApi(contract.notifications.getNotifications);

// Marks the named notifications read, or all of them when no ids are given. Returns how many are still unread.
export const markNotificationsReadQuery = async (ids?: string[]): Promise<number> => {
    const { unreadCount } = await callApi(contract.notifications.markNotificationsRead, { body: { ids } });

    return unreadCount;
};
